import { Injectable, Injector } from '@angular/core';
import { TemplateModel } from '../template/template.model';
import { ListData } from '../components/items-list/list-data.service';
import { LoadingService } from '../shared/fi-loading/loading.service';
import { DocumentTemplateService } from './document-template.service';
import { ObjectTypes } from '@fi-shared/types/object-type';
import {
    ItemsListElementType,
    ItemsListHeader,
    ItemsListHeaderProperties,
} from '@fi-app/components/items-list/items-list-header';
import { SideListOptionType } from '@fi-shared/types/side-list-option-type';
import { DocumentTemplateConfirmDeleteDialogComponent } from '@fi-app/document-template/document-template-confirm-delete-dialog/document-template-confirm-delete-dialog.component';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { takeUntil } from 'rxjs/operators';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';

@Injectable()
export class DocumentTemplateListDataService {
    constructor(
        private injector: Injector,
        private templateService: DocumentTemplateService,
        private fiDialogsService: FiDialogsService,
        private fiLoading: LoadingService,
    ) {}

    getInstance(isLocalSort?: boolean) {
        return new DocumentTemplateListData(
            this.injector,
            this.templateService,
            this.fiDialogsService,
            this.fiLoading,
            isLocalSort,
        );
    }
}

export class DocumentTemplateListData extends ListData<TemplateModel> {
    constructor(
        injector: Injector,
        templateService: DocumentTemplateService,
        fiDialogsService: FiDialogsService,
        fiLoading: LoadingService,
        isLocalSort?: boolean,
    ) {
        super(injector, isLocalSort, 'ChangedOn', true);

        this.ObjectType = ObjectTypes.Template;
        this.ShowFavoriteIcon = true;
        this.isV2SearchByContent = true;

        this.DeletePermanentlyTextId = 'template.delete_permanently_confirm';

        this.Header.push(
            new ItemsListHeader(
                '',
                '',
                new ItemsListHeaderProperties(
                    'CcmListItem-Icon CcmListItem-NoBorder',
                    true,
                    ItemsListElementType.ImgIconA,
                    {
                        Sref: FiStateNames.Document.Template.View,
                        SrefParams: (data) => ({ Id: data.Id }),
                        ImgSrc: 'Image',
                        ImgSrcLarge: 'ImageLarge',
                    },
                ),
            ),
        );

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('common.name'),
                'Name',
                new ItemsListHeaderProperties('CcmListItem-Template CcmListItem-Name', true, ItemsListElementType.A, {
                    Sref: FiStateNames.Document.Template.View,
                    SrefParams: (data) => ({ Id: data.Id }),
                    secondaryValue: (data) => {
                        return (
                            injector.get(FiFormatDateService).formatDate(data.ChangedOn, 'date') +
                            ' ' +
                            data.ChangedByUserName
                        );
                    },
                    //displayValueTemplateUrl: '/Utility/View/CcmList/CcmListItemDisplayValueWithChangedOn.html'
                }),
            ),
        );

        this.addDescriptionHeader();

        this.addChangedOnHeader();

        this.addCreatedByHeader();

        this.deleteFunc = (idsToDelete) => templateService.DeleteTemplates(idsToDelete);

        this.restoreFunc = (templatesToRestore) => {
            const templatesIdsToRestore = templatesToRestore.map((template) => template.Id);
            return templateService.RestoreTemplates(templatesIdsToRestore);
        };

        this.deleteConfirm = (deleteConfirmMessage, selectedIds: number[], selectedItems: TemplateModel[]) => {
            //return; // todo in process https://chainformation.atlassian.net/browse/FI-3200
            if (this.FilterType === SideListOptionType.Deleted) return;

            if (selectedItems.some((item) => item.IsInUse)) {
                return new Promise<TemplateModel[]>((resolve, reject) => {
                    fiDialogsService
                        .custom({
                            headerText: this.appTextService.get('template.select_templates'),
                            yesButtonText: this.appTextService.get('common.delete'),
                            contentComponentRef: DocumentTemplateConfirmDeleteDialogComponent,
                            contentComponentData: {
                                selectedItems: selectedItems,
                                getListDataInstanceFunc: (instanceIsLocalSort) => {
                                    return new DocumentTemplateListData(
                                        injector,
                                        templateService,
                                        fiDialogsService,
                                        fiLoading,
                                        instanceIsLocalSort,
                                    );
                                },
                            },
                            config: {
                                panelClass: 'dialog-confirm-delete-template',
                                maxWidth: '800px',
                                width: '800px',
                            },
                        })
                        .onYesButtonClick(resolve)
                        .onNoButtonClick(reject);
                });
            }
        };

        this.searchV2Changed$.pipe(takeUntil(this.ngOnDestroy$)).subscribe((localSearchParameter) => {
            this.setHighlightTextParam(localSearchParameter.ContentSearchTexts);
        });
    }

    appendData(items) {
        items.forEach((item) => super.initializeImage(item, item.PreviewFileName));
        super.appendData(items);
    }
}
